/**
 * ============================================================
 * ESENCIA — COLLECTION SYSTEM V14
 * SIN INTERVENCIÓN DE PRECIOS
 * ============================================================
 *
 * Colecciones:
 * - Makeup
 * - Skin Care
 *
 * Este archivo NO:
 * - crea precios
 * - modifica precios
 * - oculta precios
 * - reemplaza precios
 * - toca .nova-box-card-offer
 * - toca bloques Price de Shopify
 *
 * Únicas cantidades válidas:
 * - 5 piezas
 * - 10 piezas
 * - 15 piezas
 *
 * ============================================================
 */

(function () {

  'use strict';



  /* ==========================================================
     EVITAR DOBLE INICIALIZACIÓN
     ========================================================== */

  if (
    window.__ESENCIA_COLLECTION_V14_NO_PRICE__
  ) {

    return;

  }


  window.__ESENCIA_COLLECTION_V14_NO_PRICE__ =
    true;



  /* ==========================================================
     CONFIGURACIÓN
     ========================================================== */

  const BUILDER_HANDLE =
    'arma-tu-esencia';


  const COLLECTIONS = {

    makeup: {

      keyword:
        'makeup',

      title:
        'Makeup para',

      accent:
        'tu Esencia.',

      description:
        'Labios, blush, bases, polvos y más. Elige tus favoritos y combínalos completamente a tu manera.'

    },


    'skin-care': {

      keyword:
        'skin care',

      title:
        'Skin care para',

      accent:
        'tu Esencia.',

      description:
        'Limpieza, hidratación, protección y cuidado para complementar tu rutina con tus productos favoritos.'

    }

  };



  /* ==========================================================
     ESTADO
     ========================================================== */

  let eligibleCount =
    0;


  let eligibleProductIds =
    new Set();



  /* ==========================================================
     COLECCIÓN ACTUAL
     ========================================================== */

  function getCollectionHandle() {

    const match =
      window.location.pathname.match(
        /^\/collections\/([^/?#]+)/i
      );


    return match

      ? decodeURIComponent(
          match[1]
        ).toLowerCase()

      : '';

  }


  const collectionHandle =
    getCollectionHandle();


  const copy =
    COLLECTIONS[
      collectionHandle
    ] || null;


  if (!copy) {

    return;

  }



  /* ==========================================================
     HELPERS
     ========================================================== */

  function shopUrl(
    path
  ) {

    let root =
      window.Shopify
        ?.routes
        ?.root ||
      '/';


    if (
      !root.endsWith('/')
    ) {

      root += '/';

    }


    return (

      root +

      String(
        path || ''
      ).replace(
        /^\/+/,
        ''
      )

    );

  }



  function normalize(
    text
  ) {

    return String(
      text || ''
    )

      .normalize('NFD')

      .replace(
        /[\u0300-\u036f]/g,
        ''
      )

      .replace(
        /[^a-zA-Z0-9\s]/g,
        ' '
      )

      .replace(
        /\s+/g,
        ' '
      )

      .trim()

      .toLowerCase();

  }



  function plural(
    number,
    singular,
    pluralText
  ) {

    return (
      number === 1
        ? singular
        : pluralText
    );

  }



  /* ==========================================================
     FORZAR MODO ESENCIA
     ========================================================== */

  function forceEsenciaMode() {

    document
      .documentElement
      .dataset
      .esenciaMode =
        'esencia';


    if (
      document.body
    ) {

      document.body
        .dataset
        .esenciaMode =
          'esencia';

    }


    try {

      window.localStorage
        .setItem(
          'esencia-purchase-mode-v1',
          'esencia'
        );

    }

    catch (error) {}

  }



  /* ==========================================================
     LÓGICA DE CANTIDAD
     SIN PRECIOS
     ========================================================== */

  function getState(
    count
  ) {

    const qty =
      Math.max(
        0,
        Number(
          count || 0
        )
      );



    /* 0–4 */

    if (
      qty < 5
    ) {

      return {

        kind:
          'incomplete',

        count:
          qty,

        target:
          5,

        lower:
          0,

        add:
          5 - qty,

        remove:
          0

      };

    }



    /* 5 */

    if (
      qty === 5
    ) {

      return {

        kind:
          'complete',

        count:
          5,

        tier:
          5

      };

    }



    /* 6–9 */

    if (
      qty < 10
    ) {

      return {

        kind:
          'incomplete',

        count:
          qty,

        target:
          10,

        lower:
          5,

        add:
          10 - qty,

        remove:
          qty - 5

      };

    }



    /* 10 */

    if (
      qty === 10
    ) {

      return {

        kind:
          'complete',

        count:
          10,

        tier:
          10

      };

    }



    /* 11–14 */

    if (
      qty < 15
    ) {

      return {

        kind:
          'incomplete',

        count:
          qty,

        target:
          15,

        lower:
          10,

        add:
          15 - qty,

        remove:
          qty - 10

      };

    }



    /* 15 */

    if (
      qty === 15
    ) {

      return {

        kind:
          'complete',

        count:
          15,

        tier:
          15

      };

    }



    /* +15 */

    return {

      kind:
        'special',

      count:
        qty

    };

  }



  /* ==========================================================
     LIMPIAR SOLO ELEMENTOS CREADOS POR V11 / V12 / V13
     ========================================================== */

  function cleanupOldCustomUI() {

    /*
     * Estilos de versiones anteriores.
     */

    [

      'esencia-collection-v11-styles',
      'esencia-collection-v12-styles',
      'esencia-collection-v13-styles',
      'esencia-collection-v14-styles'

    ].forEach(
      function (id) {

        document
          .getElementById(
            id
          )
          ?.remove();

      }
    );


    /*
     * Elementos que NOSOTROS creamos en versiones anteriores.
     *
     * NO tocar:
     * .nova-box-card-offer
     *
     * porque el precio real puede estar siendo controlado
     * por otro sistema.
     */

    document
      .querySelectorAll(
        [
          '.esencia-collection-meta-v11',
          '.esencia-collection-card-price-v11',
          '.esencia-card-v12'
        ].join(',')
      )
      .forEach(
        function (element) {

          element.remove();

        }
      );


    /*
     * Quitar barras flotantes antiguas creadas por
     * este mismo archivo.
     */

    [

      'esencia-collection-counter-v11',
      'esencia-collection-counter-v12',
      'esencia-collection-counter-v13',
      'esencia-collection-counter-v14'

    ].forEach(
      function (id) {

        document
          .getElementById(
            id
          )
          ?.remove();

      }
    );


    document
      .documentElement
      .classList
      .remove(
        'esencia-collection-v11-page',
        'esencia-collection-v12-page',
        'esencia-collection-v13-page'
      );

  }



  /* ==========================================================
     CSS
     SIN ESTILOS DE PRECIO
     ========================================================== */

  function installStyles() {

    const style =
      document.createElement(
        'style'
      );


    style.id =
      'esencia-collection-v14-styles';


    style.textContent = `


      /* =====================================================
         NO MOSTRAR "VER TODO"
         ===================================================== */

      .esencia-v14-hide-collection-cta {

        display:
          none !important;

      }



      /* =====================================================
         QUITAR SWITCH MENÚDEO
         ===================================================== */

      html.esencia-collection-v14-page
      #esencia-purchase-mode {

        display:
          none !important;

      }



      /* =====================================================
         ESPACIO INFERIOR
         ===================================================== */

      html.esencia-collection-v14-page
      #MainContent {

        padding-bottom:
          92px !important;

      }



      /* =====================================================
         BARRA DE ESTADO
         SIN PRECIO
         ===================================================== */

      #esencia-collection-counter-v14 {

        position:
          fixed;

        z-index:
          99970;

        left:
          50%;

        bottom:
          max(
            8px,
            env(safe-area-inset-bottom)
          );

        width:
          min(
            560px,
            calc(100% - 18px)
          );

        max-width:
          calc(100% - 18px);

        min-height:
          57px;

        transform:
          translateX(-50%);

        display:
          grid;

        grid-template-columns:
          44px
          minmax(0,1fr);

        align-items:
          center;

        gap:
          10px;

        padding:
          7px 10px;

        overflow:
          hidden;

        border:
          1px solid
          rgba(255,255,255,.88);

        border-radius:
          21px;

        background:

          radial-gradient(
            circle at 95% 0%,
            rgba(250,171,250,.16),
            transparent 42%
          ),

          linear-gradient(
            145deg,
            rgba(255,255,255,.96),
            rgba(255,247,255,.92)
          );

        box-shadow:
          0 10px 30px
          rgba(93,47,93,.12);

        backdrop-filter:
          blur(24px)
          saturate(150%);

        -webkit-backdrop-filter:
          blur(24px)
          saturate(150%);

        color:
          #603b60;

        font-family:
          'DM Sans',
          sans-serif;

      }



      /* COUNT */

      .esencia-counter-v14__count {

        width:
          42px;

        height:
          42px;

        display:
          flex;

        flex-direction:
          column;

        align-items:
          center;

        justify-content:
          center;

        border:
          1px solid
          rgba(232,121,233,.20);

        border-radius:
          14px;

        background:
          rgba(255,250,255,.74);

      }


      .esencia-counter-v14__count
      strong {

        color:
          #603b60;

        font-size:
          16px;

        font-weight:
          800;

        line-height:
          .9;

      }


      .esencia-counter-v14__count
      span {

        margin-top:
          4px;

        color:
          #987a97;

        font-size:
          5.8px;

        font-weight:
          800;

        letter-spacing:
          .05em;

      }



      /* COPY */

      .esencia-counter-v14__copy {

        min-width:
          0;

        display:
          flex;

        flex-direction:
          column;

        justify-content:
          center;

      }


      .esencia-counter-v14__copy
      strong {

        overflow:
          hidden;

        color:
          #603b60;

        font-size:
          10px;

        font-weight:
          800;

        line-height:
          1.15;

        white-space:
          nowrap;

        text-overflow:
          ellipsis;

      }


      .esencia-counter-v14__copy
      span {

        margin-top:
          4px;

        overflow:
          hidden;

        color:
          #987d96;

        font-size:
          7px;

        font-weight:
          550;

        line-height:
          1.15;

        white-space:
          nowrap;

        text-overflow:
          ellipsis;

      }



      /* PROGRESS */

      .esencia-counter-v14__progress {

        position:
          absolute;

        left:
          12px;

        right:
          12px;

        bottom:
          3px;

        height:
          2px;

        overflow:
          hidden;

        border-radius:
          999px;

        background:
          rgba(107,53,107,.06);

      }


      .esencia-counter-v14__progress
      i {

        display:
          block;

        width:
          0%;

        height:
          100%;

        border-radius:
          inherit;

        background:
          linear-gradient(
            90deg,
            #faabfa,
            #e879e9
          );

        transition:
          width 300ms
          cubic-bezier(
            .22,
            1,
            .36,
            1
          );

      }



      /* =====================================================
         MOBILE
         ===================================================== */

      @media screen and (max-width:749px) {

        #esencia-collection-counter-v14 {

          width:
            calc(100% - 18px);

          grid-template-columns:
            42px
            minmax(0,1fr);

          gap:
            8px;

          min-height:
            55px;

          padding:
            6px 8px;

          border-radius:
            20px;

        }


        .esencia-counter-v14__count {

          width:
            40px;

          height:
            40px;

        }


        .esencia-counter-v14__copy
        strong {

          font-size:
            9.2px;

        }


        .esencia-counter-v14__copy
        span {

          font-size:
            6.5px;

        }

      }

    `;


    document.head.appendChild(
      style
    );

  }



  /* ==========================================================
     HERO
     SOLO TEXTO
     NO TOCAMOS BLOQUES DE PRECIO
     ========================================================== */

  function findHeroHeading() {

    return (

      Array.from(

        document.querySelectorAll(
          '#MainContent h1, #MainContent h2'
        )

      ).find(
        function (heading) {

          const text =
            normalize(
              heading.textContent
            );


          return (

            text.includes(
              copy.keyword
            ) &&

            (
              text.includes(
                'esencia'
              ) ||

              text.includes(
                'manera'
              )
            )

          );

        }
      ) ||

      null

    );

  }



  function getHeroRoot() {

    const heading =
      findHeroHeading();


    if (!heading) {

      return null;

    }


    return (

      heading.closest(
        'section'
      ) ||

      heading.closest(
        '.shopify-section'
      ) ||

      heading.parentElement
        ?.parentElement ||

      heading.parentElement

    );

  }



  function findDescription(
    root
  ) {

    if (!root) {

      return null;

    }


    return (

      Array.from(
        root.querySelectorAll(
          'p'
        )
      ).find(
        function (element) {

          const text =
            normalize(
              element.textContent
            );


          if (
            collectionHandle ===
            'makeup'
          ) {

            return (

              text.includes(
                'labios'
              ) &&

              text.length >
                20 &&

              text.length <
                320

            );

          }


          return (

            text.includes(
              'limpieza'
            ) &&

            text.length >
              20 &&

            text.length <
              320

          );

        }
      ) ||

      null

    );

  }



  function hideVerTodo(
    root
  ) {

    if (!root) {

      return;

    }


    Array.from(

      root.querySelectorAll(
        'a, button'
      )

    ).forEach(
      function (element) {

        const text =
          normalize(
            element.textContent
          );


        if (
          text ===
            'ver todo' ||

          text ===
            'ver todos'
        ) {

          element.classList.add(
            'esencia-v14-hide-collection-cta'
          );

        }

      }
    );

  }



  /* ==========================================================
     TEXTO DEL ESTADO
     ========================================================== */

  function statusText(
    state
  ) {

    if (
      state.kind ===
      'special'
    ) {

      return (
        'Tienes ' +
        state.count +
        ' piezas · para pedidos mayores a 15 piezas contáctanos por WhatsApp.'
      );

    }


    if (
      state.kind ===
      'complete'
    ) {

      return (
        'Tienes ' +
        state.tier +
        ' piezas · Esencia ' +
        state.tier +
        ' completa.'
      );

    }


    if (
      state.count === 0
    ) {

      return (
        'Elige 5 piezas para completar tu primera Esencia.'
      );

    }


    if (
      state.lower === 0
    ) {

      return (

        'Te faltan ' +

        state.add +

        ' ' +

        plural(
          state.add,
          'pieza',
          'piezas'
        ) +

        ' para completar Esencia 5.'

      );

    }


    return (

      'Tienes ' +

      state.count +

      ' piezas · agrega ' +

      state.add +

      ' ' +

      plural(
        state.add,
        'pieza',
        'piezas'
      ) +

      ' para Esencia ' +

      state.target +

      ' o quita ' +

      state.remove +

      ' ' +

      plural(
        state.remove,
        'pieza',
        'piezas'
      ) +

      ' para Esencia ' +

      state.lower +

      '.'

    );

  }



  /* ==========================================================
     NOTA EXISTENTE DEL HERO
     ========================================================== */

  function findHeroStatusNote(
    root
  ) {

    if (!root) {

      return null;

    }


    const candidates =

      Array.from(

        root.querySelectorAll(
          'p, span'
        )

      )
        .filter(
          function (element) {

            const text =
              normalize(
                element.textContent
              );


            return (

              text.length <
                300 &&

              (
                text.includes(
                  'tienes'
                ) ||

                text.includes(
                  'precio actual'
                ) ||

                text.includes(
                  'empieza con'
                ) ||

                text.includes(
                  'faltan'
                )
              )

            );

          }
        );


    return (
      candidates[0] ||
      null
    );

  }



  /* ==========================================================
     RENDER HERO
     ========================================================== */

  function renderHero() {

    const heading =
      findHeroHeading();


    const root =
      getHeroRoot();


    if (
      !heading ||
      !root
    ) {

      return;

    }


    /*
     * Título.
     */

    heading.innerHTML =

      copy.title +

      ' <em>' +

      copy.accent +

      '</em>';



    /*
     * Descripción.
     */

    const description =
      findDescription(
        root
      );


    if (
      description
    ) {

      description.textContent =
        copy.description;

    }



    /*
     * Quitamos "Ver todo".
     */

    hideVerTodo(
      root
    );



    /*
     * ÚNICAMENTE actualizamos la frase informativa.
     *
     * NO buscamos:
     * - amount
     * - price
     * - unit price
     * - offer
     *
     * NO modificamos ningún precio.
     */

    const note =
      findHeroStatusNote(
        root
      );


    if (
      note
    ) {

      note.textContent =

        '✦ ' +

        statusText(
          getState(
            eligibleCount
          )
        );

    }

  }



  /* ==========================================================
     BARRA SIN PRECIO
     ========================================================== */

  function createCounter() {

    let root =
      document.getElementById(
        'esencia-collection-counter-v14'
      );


    if (
      root
    ) {

      return root;

    }


    root =
      document.createElement(
        'aside'
      );


    root.id =
      'esencia-collection-counter-v14';


    root.setAttribute(
      'aria-label',
      'Estado de tu Esencia'
    );


    root.setAttribute(
      'aria-live',
      'polite'
    );


    root.innerHTML = `

      <div
        class="esencia-counter-v14__count"
      >

        <strong
          data-v14-count
        >
          0
        </strong>

        <span>
          PZS
        </span>

      </div>


      <div
        class="esencia-counter-v14__copy"
      >

        <strong
          data-v14-title
        >
          Elige 5 piezas para empezar
        </strong>

        <span
          data-v14-subtitle
        >
          Solo puedes finalizar con 5, 10 o 15 piezas
        </span>

      </div>


      <span
        class="esencia-counter-v14__progress"
        aria-hidden="true"
      >

        <i
          data-v14-progress
        ></i>

      </span>

    `;


    document.body.appendChild(
      root
    );


    return root;

  }



  /* ==========================================================
     PROGRESO
     ========================================================== */

  function progressForState(
    state
  ) {

    if (
      state.kind ===
      'special'
    ) {

      return 100;

    }


    if (
      state.kind ===
      'complete'
    ) {

      return 100;

    }


    if (
      state.target ===
      5
    ) {

      return Math.max(

        0,

        Math.min(

          100,

          (
            state.count /
            5
          ) * 100

        )

      );

    }


    const total =

      state.target -

      state.lower;


    const current =

      state.count -

      state.lower;


    return Math.max(

      0,

      Math.min(

        100,

        (
          current /
          total
        ) * 100

      )

    );

  }



  /* ==========================================================
     RENDER BARRA
     ========================================================== */

  function renderCounter() {

    const root =
      createCounter();


    const state =
      getState(
        eligibleCount
      );


    const count =
      root.querySelector(
        '[data-v14-count]'
      );


    const title =
      root.querySelector(
        '[data-v14-title]'
      );


    const subtitle =
      root.querySelector(
        '[data-v14-subtitle]'
      );


    const progress =
      root.querySelector(
        '[data-v14-progress]'
      );


    count.textContent =
      String(
        eligibleCount
      );


    progress.style.width =

      progressForState(
        state
      ) +

      '%';



    /* MÁS DE 15 */

    if (
      state.kind ===
      'special'
    ) {

      title.textContent =
        'Compra especial';


      subtitle.textContent =
        state.count +
        ' piezas · contáctanos por WhatsApp';


      return;

    }



    /* 5 / 10 / 15 */

    if (
      state.kind ===
      'complete'
    ) {

      title.textContent =

        'Esencia ' +

        state.tier +

        ' lista ✦';


      subtitle.textContent =
        'Cantidad válida · puedes continuar';


      return;

    }



    /* 0 */

    if (
      state.count ===
      0
    ) {

      title.textContent =
        'Elige 5 piezas para empezar';


      subtitle.textContent =
        'Solo puedes finalizar con 5, 10 o 15 piezas';


      return;

    }



    /* MENOS DE 5 */

    if (
      state.lower ===
      0
    ) {

      title.textContent =
        'Compra incompleta · ' +
        state.count +
        ' piezas';


      subtitle.textContent =

        'Agrega ' +

        state.add +

        ' ' +

        plural(
          state.add,
          'pieza',
          'piezas'
        ) +

        ' para Esencia 5';


      return;

    }



    /* ENTRE NIVELES */

    title.textContent =
      'Compra incompleta · ' +
      state.count +
      ' piezas';


    subtitle.textContent =

      'Agrega ' +

      state.add +

      ' o quita ' +

      state.remove +

      ' para completar una Esencia válida';

  }



  /* ==========================================================
     PRODUCTOS QUE CUENTAN
     ========================================================== */

  async function loadEligibleProductIds() {

    try {

      const response =
        await fetch(

          shopUrl(

            'collections/' +

            BUILDER_HANDLE +

            '/products.json?limit=250'

          ),

          {

            credentials:
              'same-origin',

            headers: {

              Accept:
                'application/json'

            }

          }

        );


      if (
        !response.ok
      ) {

        return;

      }


      const data =
        await response.json();


      eligibleProductIds =

        new Set(

          Array.isArray(
            data.products
          )

            ? data.products.map(
                function (product) {

                  return Number(
                    product.id
                  );

                }
              )

            : []

        );

    }

    catch (error) {

      console.warn(
        'Esencia V14: no se pudo cargar la colección principal.',
        error
      );

    }

  }



  /* ==========================================================
     LEER CARRITO
     ========================================================== */

  async function refreshCart() {

    try {

      const response =
        await fetch(

          shopUrl(

            'cart.js?esenciaCollectionStatus=' +

            Date.now()

          ),

          {

            credentials:
              'same-origin',

            headers: {

              Accept:
                'application/json'

            }

          }

        );


      if (
        !response.ok
      ) {

        return;

      }


      const cart =
        await response.json();


      let count =
        0;


      cart.items.forEach(
        function (item) {

          const properties =
            item.properties ||
            {};


          const title =
            String(

              item.product_title ||

              item.title ||

              ''

            ).toLowerCase();



          /* REGALOS NO CUENTAN */

          const isGift =

            properties._esencia_gift ===
              'true' ||

            properties._gift ===
              'true' ||

            title.includes(
              'regalo esencia'
            );



          /* HELPERS NO CUENTAN */

          const isHelper =

            properties._esencia_extra_helper ===
              'true';


          if (
            isGift ||
            isHelper
          ) {

            return;

          }



          /* SOLO COLECCIÓN ARMA TU ESENCIA */

          if (

            eligibleProductIds.has(

              Number(
                item.product_id
              )

            )

          ) {

            count +=

              Number(
                item.quantity ||
                0
              );

          }

        }
      );


      eligibleCount =
        count;


      renderHero();

      renderCounter();



      /*
       * Compartimos SOLO EL CONTEO
       * con los demás sistemas.
       *
       * Este archivo no envía ningún precio.
       */

      document.dispatchEvent(

        new CustomEvent(

          'esencia:eligible-count-change',

          {

            detail: {

              count:
                eligibleCount,

              mode:
                'esencia'

            }

          }

        )

      );

    }

    catch (error) {

      console.warn(
        'Esencia V14: no se pudo leer el carrito.',
        error
      );

    }

  }



  /* ==========================================================
     DETECTAR CAMBIOS AL CARRITO
     ========================================================== */

  function watchCartFetch() {

    if (
      window.__ESENCIA_COLLECTION_V14_FETCH__
    ) {

      return;

    }


    window.__ESENCIA_COLLECTION_V14_FETCH__ =
      true;


    const originalFetch =
      window.fetch;


    window.fetch =
      async function () {

        const response =

          await originalFetch.apply(
            this,
            arguments
          );


        try {

          const input =
            arguments[0];


          const url =

            typeof input ===
            'string'

              ? input

              : input?.url ||
                '';


          if (

            /\/cart\/(add|change|update|clear)(\.js)?/i
              .test(
                url
              )

          ) {

            window.setTimeout(
              refreshCart,
              150
            );

          }

        }

        catch (error) {}


        return response;

      };

  }



  /* ==========================================================
     EVENTOS
     ========================================================== */

  document.addEventListener(
    'esencia:cart-changed',
    refreshCart
  );


  document.addEventListener(
    'cart:updated',
    refreshCart
  );


  document.addEventListener(
    'cart:change',
    refreshCart
  );


  document.addEventListener(
    'esencia:floating-cart-refresh',
    refreshCart
  );


  document.addEventListener(
    'shopify:section:load',

    function () {

      window.setTimeout(
        function () {

          renderHero();

          renderCounter();

        },
        120
      );

    }
  );


  window.addEventListener(
    'pageshow',

    function () {

      window.setTimeout(
        refreshCart,
        120
      );

    }
  );


  document.addEventListener(
    'visibilitychange',

    function () {

      if (
        document.visibilityState ===
        'visible'
      ) {

        refreshCart();

      }

    }
  );



  /* ==========================================================
     START
     ========================================================== */

  async function start() {

    cleanupOldCustomUI();


    forceEsenciaMode();


    installStyles();


    document
      .documentElement
      .classList
      .add(
        'esencia-collection-v14-page'
      );


    createCounter();


    renderHero();

    renderCounter();


    watchCartFetch();



    await loadEligibleProductIds();

    await refreshCart();


    window.setTimeout(
      function () {

        renderHero();

        renderCounter();

      },
      350
    );


    window.setTimeout(
      function () {

        renderHero();

        renderCounter();

      },
      900
    );

  }


  start();


})();